import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { InterestOptions } from 'src/shared/constants/interestOptions';

@Component({
  selector: 'app-editorg',
  templateUrl: './editorg.component.html',
  styleUrls: ['./editorg.component.css', '../../shared/styles/formStyles.css']
})
export class EditorgComponent {
  name: string | undefined;
  description: string | undefined;
  interests: string[] | undefined;
  advanced = false;

  interestOptions: { [key: string]: string } = InterestOptions;
  interestKeys: string[] = Object.keys(this.interestOptions);

  constructor(
    private router: Router
  ) { }

  onCheckChange(event: Event, key: string) {
    if (!event.target) return;

    this.interests = this.interests ?? [];

    if ((event.target as HTMLInputElement).checked) {
      this.interests.push(key);
    } else {
      const index = this.interests.indexOf(key, 0) ?? -1;
      if (index > -1) {
        this.interests.splice(index, 1);
      }
    }
  }

  submit(): void {

    const name = this.name ?? "";
    const description = this.description ?? "";
    const interests = this.interests ?? [];


    console.log(interests);

    this.router.navigate(['/homepage']);
  }

  showAdvanced(): void {
    this.advanced = true;
  }

  hideAdvanced(): void {
    this.advanced = false;
  }

  deleteOrg(): void {
    if (window.confirm("Are you sure you want to delete this organization?")) {
      // delete user
    }
  }

}
